<template>
  <div>
      <CardWithImageAndButton
      title="Профиль клиента"
      text="
      Высокопроизводительное решение для агрегации, обработки и витринизации персональных данных с поддержкой нечеткого матчинга, обезличивания и соответствием требованиям регуляторов.
      <br /><br />
      Система поддерживает интеграцию с более чем 80 источниками, включая внутренние и внешние базы, API и неструктурированные хранилища.
      <br /><br />
      Каждый процесс загрузки сопровождается формированием технического отчета и встроенной системой фильтрации логических контролей (ФЛК), обеспечивая надёжность и прозрачность всего цикла.
      <br /><br />
      Используемые технологии: Go, JavaScript.
      "
      :imagePath="require('../../assets/imgs/client-profile.png')"
      imagePosition="left"
      :buttonIsVisible="false"
      />
      <List :items="listItems" title="Задачи" theme="dark" />
      <List title="Реализация" :items=secondListItems />
      <MultiColumnListWithIcons
      header="Масштаб и потенциал системы"
      text="Объем данных превышает 1 петабайт, охватывая более 160 миллионов клиентских профилей и более 3000 признаков. Это обеспечивает высокую точность и глубину аналитики для принятия стратегических решений."
      :items="multiColumnListItems"
      theme="dark"
      />
  </div>
</template>

<script>
import { CardWithImageAndButton, List, MultiColumnListWithIcons } from 'sputnik-ui/src/index';
export default {
  name: 'ClientProfilePage',
  components: {
    CardWithImageAndButton,
    List,
    MultiColumnListWithIcons
  },
  data() {
    return {
      listItems: [
        { text: 'Разработать форматы данных для 80+ источников'},
        { text: 'Разработать алгоритмы матчинга'},
        { text: 'Разработать адаптивный конфигурируемы загрузчик'},
        { text: 'Реализовать ФЛК при загрузке с подготовкой отчета'},
        { text: 'Использовать только СПО'},
        { text: 'Выполнить требования ФСБ по защите данных'},
      ],
      secondListItems: [
        {text: "Создали «чудовищно» быструю систему загрузки"},
        {text: "Разработали систему построения профилей налету"},
        {text: "Впервые применили технологии обезличивания"},
        {text: "Поддерживается матчинг по нечетким данным, в том числе с не структурированными базами данных"},
        {text: "Создали собственную систему витринизации данных"},
      ],
      multiColumnListItems: [
        {
          icon: require('@/assets/icons/star.svg'),
          header: '> 1 ПТб',
          text: 'данных'
        },
        {
          icon: require('@/assets/icons/star.svg'),
          header: '> 160',
          text: 'млн профилей'
        },
        {
          icon: require('@/assets/icons/star.svg'),
          header: '> 3000',
          text: 'признаков'
        },
      ]
    };
  },
};
</script>
